import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-10 text-center sm:pt-16" data-id="element-101">
      <div className="absolute inset-0 -z-0 bg-[radial-gradient(ellipse_at_top,rgba(184,134,11,.25),transparent_58%)]" data-id="element-102" />
      <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-center" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} className="rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-[10px] font-medium tracking-wide text-gold-light sm:text-sm" data-id="element-104">
          MEGA PACK HISTORIA 360
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mt-5 max-w-4xl font-serif text-3xl font-bold leading-tight sm:text-5xl lg:text-6xl" data-id="element-105">
          Resuelve un año entero de clases de Historia en solo{' '}
          <span className="text-gold-gradient" data-id="element-106">5 MINUTOS.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="relative my-5 w-full max-w-[270px] sm:max-w-lg" data-id="element-107">
          <div className="absolute inset-10 rounded-full bg-gold/20 blur-[70px]" data-id="element-108" />
          <img className="relative w-full drop-shadow-2xl" src="https://cdn.magicpatterns.com/uploads/rvyQFKE5WWsmCxiY9mRHMr/seguridad_e_higiene_(4).png" alt="Mega Pack Historia 360" data-id="element-109" />
        </motion.div>

        <p className="max-w-2xl text-sm leading-relaxed text-gray-300 sm:text-lg" data-id="element-110">
          El sistema completo para planificar, enseñar y evaluar — listo para
          usar desde hoy.
        </p>

        <Button href="#pricing" className="my-6 text-sm sm:text-lg" data-id="element-111">
          QUIERO MI MEGA PACK AHORA
        </Button>

        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400" data-id="element-112">
          {['8 tomos premium', '4 bonos estratégicos', 'Acceso inmediato'].map(item => <span key={item} className="flex items-center gap-1.5" data-id="element-113">
                <CheckCircle2 size={14} className="text-gold" data-id="element-114" />
                {item}
              </span>)}
        </div>
      </div>
    </section>;
}